export default __webpack_public_path__ + "static/media/640_business06-es-web.7dc86eb9.png";